// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Components
import Section from '../../../layout/Section';

// Types
type $OptionalProps = {
  message?: string;
};

type $Props = $OptionalProps & $Translate & {
  id: string;
};

const NotFoundSectionView = function ({
  id,
  message,
  t,
}: $Props) {
  return (
    <Section id={id}>
      <div className={'text-gray-600 flex items-center justify-center py-20'}>
        <em className={'la la-water text-2xl mr-2'} />
        <span>{message || t('Page not found')}</span>
      </div>
    </Section>
  );
};

NotFoundSectionView.defaultProps = {
  message: undefined,
};

export default NotFoundSectionView;
